"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderThumb = exports.ControlStyled = exports.UnitStyled = exports.ValueStyled = exports.ValueWrapper = exports.SliderWrapperStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Color_enum_1 = require("../../constants/Color.enum");
exports.SliderWrapperStyled = styled_components_1.default.div `
    display: flex;
    align-items: center;

    .horizontal-slider {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: ${(props) => (props.disabled ? '0.3' : '1')};
        pointer-events: ${(props) => (props.disabled ? 'none' : 'initial')};
        user-select: none;

        .track {
            height: 2px;
            border-radius: 10px;

            &.track-0 {
                background: ${Color_enum_1.Color.Primary};
            }
            &.track-1 {
                background: ${(props) => props.trackBackgroundColor || Color_enum_1.Color.Variant_1};
            }
        }

        .thumb-0 {
            justify-content: center;

            &:hover {
                justify-content: space-between;
            }
        }
    }
`;
exports.ValueWrapper = styled_components_1.default.div `
    display: flex;
    align-items: center;
`;
exports.ValueStyled = styled_components_1.default.div `
    margin-right: 1px;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: ${Color_enum_1.Color.Primary};
`;
exports.UnitStyled = styled_components_1.default.div `
    font-weight: 500;
    font-size: 10px;
    line-height: 20px;
    color: ${Color_enum_1.Color.Secondary};
    top: 2px;
    bottom: 2px;
`;
exports.ControlStyled = styled_components_1.default.div `
    display: none;
    align-items: center;
    height: 26px;
    border-radius: 100%;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    transition-property: opacity;
    opacity: ${(props) => (props.hidden ? 0 : 1)};
    width: 26px;
    pointer-events: ${(props) => (props.hidden ? 'none' : 'initial')};

    &:hover {
        color: ${Color_enum_1.Color.Surface};
        background: ${Color_enum_1.Color.Secondary};
    }

    &:active {
        background: ${Color_enum_1.Color.Variant_1};
    }
`;
exports.SliderThumb = styled_components_1.default.div `
    outline: none;
    border: 1px solid ${Color_enum_1.Color.Variant_1};
    display: flex;
    align-items: center;
    width: 72px;
    height: 36px;
    padding: 0 5px;
    justify-content: space-between;
    border-radius: 100px;
    transition: all 0.1s linear;
    transition-property: width, margin;
    background-color: ${Color_enum_1.Color.Surface};
    cursor: pointer;
    border-radius: 100px;
    color: ${Color_enum_1.Color.Black};

    &:hover {
        width: 110px;
        margin-left: -19px;

        ${exports.ControlStyled} {
            display: flex;
        }
    }
`;
